import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'
import { getQuestionTitle } from '../../../utils/QuestionHelper'
import QuestionElement from './QuestionElement' // change for newer QuestionItemList
import Button from '../../../UniformComponents/Button'
import Modal from '../../../UniformComponents/Modal'

import './styles/mandatoryPopup.scss'

// stages: 0 = init; 1 = has missing questions; 2 = has mising SG option
@observer
class MandatoryPopup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            stage: undefined,
            smartGridQuestions: [],
            recommendedQuestions: {},
            mandatoryQuestions: {},
            hasInheritedQuestions: false,
            loading: true,
            dontLoad: false,
            dismissed: false,
            questionsAdded: false,
            initialised: false,
        }
        const { store } = props
        if (!store.survey.mandatoryPopupShown) {
            this.init()
            store.survey.mandatoryPopupShown = true
        } else {
            this.init(true)
        }

        const { stage } = this.state
        if (stage === 0) this.setState({ dontLoad: true })
    }

    init = (mandatoryOnly) => {
        let stage = 0
        const smartGridQuestions = this.getSmartQuestions()

        if (smartGridQuestions && smartGridQuestions.length) stage = 2

        const {
            missingRecommended,
            missingMandatory,
        } = this.getMissingRecommendedMandatory(mandatoryOnly)

        if (Object.keys(missingMandatory).length
            || Object.keys(missingRecommended).length) stage = 1

        this.setState({
            stage,
            smartGridQuestions,
            recommendedQuestions: missingRecommended,
            mandatoryQuestions: missingMandatory,
            loading: false,
            initialised: true
        })
    }

    getSmartQuestions = () => {
        const { store } = this.props
        const { survey } = store

        const questions = survey.pages
            .map((p) => (p.questions ? p.questions.map((q) => ({ ...q, page: p })) : undefined))
            .filter((q) => q !== undefined && q.length).slice().flat()

        const smartGridQuestions = questions
            .filter((question) => question.question !== undefined && question.question.questionTypeCode === 'SG'
                && (!R.pathOr([], ['optionSetY', 'options'], question).length))

        return smartGridQuestions
    }

    editQuestion = (question) => {
        const {
            store,
        } = this.props
        const { page } = question

        store.questionDetails = {
            action: 'editQuestion',
            prevQuestions: page.prev_questions,
            parentId: page.prev_questions.find((inherit) => inherit.value === question.parentId),
            oid: question.oid,
            pageQuestionId: question.id,
            survey: store.survey,
            tokenData: store.tokenData,
            questionId: question.questionId,
            questionIndex: question.priority - 1,
            usedInOtherSurveys: question.usedInOtherSurveys,
            usedInParentSurvey: question.usedInParentSurvey,
            pageIndex: page.priority - 1,
            smartGrid: question.question.questionTypeCode === 'SG' ? question.optionSetY : undefined,
        }
        store.showQuestionEditor = true
        this.close()
    }

    getMissingRecommendedMandatory = (mandatoryOnly = false) => {
        const { store } = this.props
        const { survey } = store
        const { questionLibrary } = survey
        const { questionLibraryStore } = questionLibrary

        const missingRecommended = {}
        const missingMandatory = {}
        const surveyQuestionIds = new Set()
        survey.pages.forEach((p) => {
            p.questions?.forEach((q) => {
                surveyQuestionIds.add(q.questionId.toLowerCase())
            })
        })

        const allMandatory = questionLibraryStore.questionLibraryLists.get('mandatory')

        allMandatory.forEach((mq) => {
            const questionFound = surveyQuestionIds.has(mq.questionId.toLowerCase())
            if (!questionFound) {
                missingMandatory[mq.objectname] = missingMandatory[mq.objectname] || []
                missingMandatory[mq.objectname].push(mq)
            }
        })

        if (!mandatoryOnly) {
            const allRecommended = questionLibraryStore.questionLibraryLists.get('recommended')
            allRecommended.forEach((rq) => {
                const questionFound = surveyQuestionIds.has(rq.questionId.toLowerCase())
                if (!questionFound) {
                    missingRecommended[rq.objectname] = missingRecommended[rq.objectname] || []
                    missingRecommended[rq.objectname].push(rq)
                }
            })
        }
        return { missingRecommended, missingMandatory }
    }

    getObjectNameText = (objectName) => {
        const { store } = this.props
        const { userData, survey } = store
        const { metadata } = survey
        switch (objectName) {
            case 'Client':
                return userData.clientName
            case 'Survey':
                return survey.content.get(store.langcode).text
            case 'Product':
                return metadata.productInfo.productName
            case 'Portfolio':
                return survey.portfolioName
            default:
                return 'other'
        }
    }

    getTitleByLocale = ({ question }) => {
        const { store } = this.props
        const locale = store.surveyLocale
        const { defaultLocale } = store.survey.metadata
        const { langcode } = store
        const titleMap = question.content.shortTitle

        let title = ''

        if (titleMap.has(locale)) {
            title = titleMap.get(locale).text
        } else if (titleMap.has(defaultLocale)) {
            title = titleMap.get(defaultLocale).text
        } else if (titleMap.has(langcode)) {
            title = titleMap.get(langcode).text
        }
        return title
    }

    getQuestionTitleByLocale = (question) => {
        const { store } = this.props
        const { surveyLocale } = store.surveyLocale
        const { initialLocale } = question
        const { defaultLocale } = store.survey.metadata
        const titleObj = question.locales

        return R.pathOr(question.title, ['text'], getQuestionTitle({
            content: titleObj, locale: surveyLocale, defaultLocale, initialLocale,
        }))
    }

    close = (smartGridQuestions) => {
        const { stage } = this.state
        if (stage === 1 && smartGridQuestions.length) {
            return this.setState({ stage: 2, questionsAdded: false, smartGridQuestions })
        }
        return this.setState({ dismissed: true })
    }

    renderCard = (type, questions) => (
        Object.keys(questions).map((category) => (
            <div className="missingQuestionsCard">
                <div className="header">
                    <p>
                        {`${type} questions set across all `}
                        <span>{`${this.getObjectNameText(category)} surveys`}</span>
                    </p>
                </div>
                <div className="questionList">
                    {this.renderQuestions(questions[category])}
                </div>
            </div>
        ))
    )

    renderQuestions = (questions) => {
        const { stage } = this.state
        const { store } = this.props

        return questions.map((q) => (
            <QuestionElement
                title={stage !== 2 ? this.getQuestionTitleByLocale(q) : this.getTitleByLocale(q)}
                question={q}
                store={store}
                stage={stage}
                editQuestion={() => this.editQuestion(q)}
            />
        ))
    }

    getModalTitle = () => {
        const { stage, mandatoryQuestions, recommendedQuestions } = this.state

        if (stage === 2) return 'Missing'

        const mandatoryQExists = Object.keys(mandatoryQuestions).length
        const reccomendedQExists = Object.keys(recommendedQuestions).length

        if (mandatoryQExists && reccomendedQExists) return 'Missing'

        if (mandatoryQExists) return 'Mandatory'

        return 'Recommended'
    }

    getModalSubTitle = () => {
        const { stage, mandatoryQuestions, recommendedQuestions } = this.state

        const mandatoryMissing = Object.keys(mandatoryQuestions).length
        const recommendedMissing = Object.keys(recommendedQuestions).length

        if (stage === 2) return 'missing'

        if (mandatoryMissing && recommendedMissing) return 'mandatory&recommended'
        if (mandatoryMissing) return 'mandatory'
        return 'recommended'
    }

    addQuestion = async (question, survey) => {
        const { store } = this.props
        if (question.parentId) {
            this.setState({ hasInheritedQuestions: true })
            return
        }
        question.oid = question.questionoid
        await survey.pages[0].addQuestion({ question, survey, store })
    }

    addQuestions = (recOrMan) => {
        const { store } = this.props
        const { survey } = store
        const { mandatoryQuestions, recommendedQuestions } = this.state

        const addAllMandatory = async () => {
            for (const category of Object.keys(mandatoryQuestions)) {
                for (const mq of mandatoryQuestions[category]) {
                    await this.addQuestion(mq, survey)
                }
            }
        }
        const addAllRecommended = async () => {
            for (const category of Object.keys(recommendedQuestions)) {
                for (const rq of recommendedQuestions[category]) {
                    await this.addQuestion(rq, survey)
                }
            }
        }

        switch (recOrMan) {
            case 'all':
                addAllMandatory()
                addAllRecommended()
                break
            case 'mandatory':
                addAllMandatory()
                break
            case 'recommended':
                addAllRecommended()
                break
            default:
                console.warn(`Invalid argument "${recOrMan}" passed to addQuestions()`)
                break
        }
        this.setState({ questionsAdded: true, loading: false })
    }

    renderButtons = () => {
        const {
            stage, mandatoryQuestions, recommendedQuestions, smartGridQuestions, loading, questionsAdded,
        } = this.state

        if (questionsAdded) {
            return (
                <Button onClick={() => this.close(smartGridQuestions)} cssClass="primary">
                    OK
                </Button>
            )
        }

        const closeButton = (
            <Button onClick={() => this.close(smartGridQuestions)} cssClass="tertiary" disabled={loading}>
                {i18n.t('surveyBuilder.modal.mandatory.btn1')}
            </Button>
        )

        if (stage === 2) return closeButton

        const addMandatoryButton = (
            <Button
                onClick={() => this.addQuestions('mandatory')}
                cssClass="primary"
                disabled={loading}
            >
                {i18n.t('surveyBuilder.modal.mandatory.btn2')}
            </Button>
        )

        const addRecommendedButton = (
            <Button
                onClick={() => this.addQuestions('recommended')}
                cssClass="primary"
                disabled={loading}
            >
                {i18n.t('surveyBuilder.modal.mandatory.btn3')}
            </Button>
        )

        const addRecommendedAndMandatoryButton = (
            <Button
                onClick={() => this.addQuestions('all')}
                cssClass="primary"
                disabled={loading}
            >
                {i18n.t('surveyBuilder.modal.mandatory.btn4')}
            </Button>
        )

        const mandatoryQExists = Object.keys(mandatoryQuestions).length
        const reccomendedQExists = Object.keys(recommendedQuestions).length

        return (
            <Fragment>
                {closeButton}
                {mandatoryQExists ? addMandatoryButton : null }
                {reccomendedQExists && mandatoryQExists
                    ? addRecommendedAndMandatoryButton : null}
                {reccomendedQExists && !mandatoryQExists ? addRecommendedButton : null}
            </Fragment>
        )
    }

    getModalTitles = () => {
        const {
            stage,
            questionsAdded,
            hasInheritedQuestions,
        } = this.state

        const title = this.getModalTitle()
        let modalTitle = ''
        let modalSubTitle = ''

        if (!questionsAdded) {
            modalTitle = `${title} ${stage === 1 ? 'Question' : 'Options'} Alert`
            modalSubTitle = i18n.t(`mandatoryPopup_explanation_${this.getModalSubTitle()}`)
        } else if (hasInheritedQuestions) {
            modalTitle = i18n.t('mandatoryPopup_title_containsInheritedQuestion')
            modalSubTitle = i18n.t('mandatoryPopup_explanation_containsInheritedQuestion')
        } else {
            modalTitle = i18n.t('mandatoryPopup_title_questionsAdded')
            modalSubTitle = i18n.t('mandatoryPopup_explanation_questionsAdded')
        }
        return { modalTitle, modalSubTitle }
    }

    getShowModal = () => {
        const {
            mandatoryQuestions,
            recommendedQuestions,
            smartGridQuestions,
            dismissed,
        } = this.state

        const hasMandatoryMissing = Object.keys(mandatoryQuestions).length
        const hasRecommendedMissing = Object.keys(recommendedQuestions).length
        const hasSGOptionsMissing = smartGridQuestions.length
        return dismissed ? false : (hasMandatoryMissing
            || hasRecommendedMissing
            || hasSGOptionsMissing)
    }

    render() {
        const {
            stage,
            mandatoryQuestions,
            recommendedQuestions,
            smartGridQuestions,
            dontLoad,
            questionsAdded,
            initialised,
        } = this.state
        const { isOtherModalOpened } = this.props
        if (dontLoad || isOtherModalOpened) return null
        if (!initialised) this.init()

        const hasMandatoryMissing = Object.keys(mandatoryQuestions).length !== 0
        const hasRecommendedMissing = Object.keys(recommendedQuestions).length !== 0
        const { modalTitle, modalSubTitle } = this.getModalTitles()
        const showModal = this.getShowModal()

        return (
            <Modal
                show={showModal}
                onClose={() => this.close(smartGridQuestions)}
                cssClass="large"
                containsScroll
            >
                <div id="missing-questions-modal" className="no-scroll-wrapper">
                    <div className="uc-modal__header">
                        <h2>{modalTitle}</h2>
                        {modalSubTitle
                            && <p className="uc-modal__desc sm" dangerouslySetInnerHTML={{ __html: modalSubTitle }} />}
                    </div>

                    {!questionsAdded && (
                        <div className="uc-modal__scrollable-content">
                            {stage === 1 && hasMandatoryMissing && this.renderCard('Mandatory', mandatoryQuestions)}
                            {stage === 1 && hasRecommendedMissing
                                && this.renderCard('Recommended', recommendedQuestions)}
                            {stage === 2 ? this.renderQuestions(smartGridQuestions) : null}
                        </div>
                    )}

                    <div className="uc-modal__button-panel large">
                        {this.renderButtons()}
                    </div>
                </div>
            </Modal>
        )
    }
}

export default MandatoryPopup
